import { combineReducers } from '@reduxjs/toolkit';
import loading, { loadingInitialState } from './slicers/loading.slice';
import apiMessage, { apiMessageInitialState } from './slicers/api-message.slice';
import auth, { authInitialState } from './slicers/auth.slice';
import platform, { platformInitialState } from '@/redux/slicers/platform.slice';
import store, { storeInitialState } from '@/redux/slicers/store.slice';
import breadcrumb, { breadcrumbInitialState } from '@/redux/slicers/breadcrumb.slice';
import roles, { rolesInitialState } from '@/redux/slicers/roles.slice';
import order, { orderInitialState } from './slicers/order.slice';
import department, { departmentInitialState } from '@/redux/slicers/department.slice';
import user, { userInitialState } from '@/redux/slicers/user.slice';
import manageRole, { manageRoleInitialState } from '@/redux/slicers/manage-role.slice';
import functions, { functionsInitialState } from '@/redux/slicers/functions.slice';
import userPage, { userPageInitialState } from '@/redux/slicers/user-page.slice';
import factory, { factoryInitialState } from '@/redux/slicers/factory.slice';
import sheet, { sheetInitialState } from '@/redux/slicers/sheet.slice';
import factoryDashboard, {
  factoryDashboardInitialState,
} from '@/redux/slicers/factory-dashboard.slice';
import fulfillment, { fulfillmentInitialState } from '@/redux/slicers/fulfillment.slice';
import media, { mediaInitialState } from '@/redux/slicers/media.slice';
import sidebar, { sidebarInitialState } from '@/redux/slicers/sidebar.slice';
import team, { teamInitialState } from '@/redux/slicers/team.slice';
import rule, { ruleInitialState } from '@/redux/slicers/rule.slice';

export type RawRootState = typeof rootState;
export const allInitialStates = {
  loadingInitialState,
  apiMessageInitialState,
  authInitialState,
  platformInitialState,
  storeInitialState,
  breadcrumbInitialState,
  rolesInitialState,
  orderInitialState,
  departmentInitialState,
  userInitialState,
  manageRoleInitialState,
  functionsInitialState,
  userPageInitialState,
  factoryInitialState,
  sheetInitialState,
  factoryDashboardInitialState,
  fulfillmentInitialState,
  mediaInitialState,
  sidebarInitialState,
  teamInitialState,
  ruleInitialState,
};
const rootState = {
  loading,
  apiMessage,
  auth,
  platform,
  store,
  breadcrumb,
  roles,
  order,
  department,
  user,
  manageRole,
  functions,
  userPage,
  factory,
  sheet,
  factoryDashboard,
  fulfillment,
  media,
  sidebar,
  team,
  rule,
};

const rootReducer = combineReducers(rootState);
export const rootReducers = rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
